module.exports = __webpack_public_path__ + "static/media/hong-kong-post.473adf39.svg";